/* eslint-disable */
import { postConexion } from './../conexion/Conexion';
import type { AppThunk } from '../store';
import { createSlice } from '@reduxjs/toolkit';
import { getEtlStatus } from 'src/components/bridges/BrigdeNotification';

// interface IndicatorsState {
//   businessEfectivoMaxio: Array<any>;
// }

const initialState = {
  list: []
}

const now = new Date();

const slice = createSlice({
  name: 'indicator',
  initialState,
  reducers: {
    getIndicators(state, action) {
      state.list = action.payload;
    }
  }
});

export const getIndicators = () => async (dispatch) => {
  const fecha = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
  const rolUser = localStorage.getItem('rolUser');
  const bussinessId = localStorage.getItem('bussinessId');

  if (rolUser === 'master') {
    const obj = {
      businessId: bussinessId
    };
    const response = await postConexion('cash/getEtlStatus', obj);
    dispatch(slice.actions.getIndicators(response));
  }
};

export const { reducer } = slice;

export default slice;
